module.exports = __webpack_public_path__ + "img/gal-5.c78e8f1a.jpg";